import VueTable from "./components/VueTable.vue";

export default VueTable;
